import CustomButton from '../../../common/components/CustomButton';
import CustomTextInput from '../../../common/components/CustomTextInput';
import Tooltip from '../../../common/components/Tooltip';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type CopyrightCollectFormView1FieldName = 'copyright_transfer_type';
type CopyrightCollectFormView1KaraokeAuthorFieldName = 'pseudonym'|'email';

export default function CopyrightCollectFormView1({
  getValue,
  addItem,
  getItemCount,
  getItemCountMax,
  getItemValue,
  setItemValue,
  getItemErrors,
  onBack,
  onNext,
} : {
  getValue: (name: CopyrightCollectFormView1FieldName) => string,
  addItem: (collection: 'karaoke_authors') => void,
  getItemCount: (collection: 'karaoke_authors') => number,
  getItemCountMax: (collection: 'karaoke_authors') => number,
  getItemValue: (collection: 'karaoke_authors', index: number, name: CopyrightCollectFormView1KaraokeAuthorFieldName) => string,
  setItemValue: (collection: 'karaoke_authors', index: number, name: CopyrightCollectFormView1KaraokeAuthorFieldName, value: string) => void,
  getItemErrors: (collection: 'karaoke_authors', index: number, name: CopyrightCollectFormView1KaraokeAuthorFieldName) => FieldValidationErrorsType,
  onBack: () => void,
  onNext: () => void,
}) {
  return (
    <>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright_pt1.png" alt="著作権の手続き" />
        </div>
      </div>
      <p className="mb50">「著作権譲渡契約」のための契約書を作成し、作詞者・作曲者の方にメールで通知いたします。対象の方のメールアドレスをご入力ください。</p>
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            {getValue('copyright_transfer_type') === '1' && (
              <dl>
                <dd>
                  {[...Array(getItemCount('karaoke_authors')).keys()].map((index) => (
                    <ul
                      key={index} // eslint-disable-line react/no-array-index-key
                      className="col"
                      style={{ float: 'none' }}
                    >
                      <li className="col span_24">
                        <span className="col span_6">
                          筆名
                          {index === 0 && (
                            <span className="asterisk">※</span>
                          )}
                          <Tooltip message="作詞・作曲者として使用されているペンネームです。公開される場合があります。" />
                        </span>
                        <span className="col span_18">
                          <CustomTextInput
                            placeholder="鈴木 太郎"
                            value={getItemValue('karaoke_authors', index, 'pseudonym')}
                            setValue={(value) => setItemValue('karaoke_authors', index, 'pseudonym', value)}
                            validationErrors={getItemErrors('karaoke_authors', index, 'pseudonym')}
                          />
                        </span>
                      </li>
                      <li className="col span_24">
                        <span className="col span_6">
                          メールアドレス
                          {index === 0 && (
                            <span className="asterisk">※</span>
                          )}
                        </span>
                        <span className="col span_18">
                          <CustomTextInput
                            placeholder="abc@abc.com"
                            value={getItemValue('karaoke_authors', index, 'email')}
                            setValue={(value) => setItemValue('karaoke_authors', index, 'email', value)}
                            validationErrors={getItemErrors('karaoke_authors', index, 'email')}
                          />
                        </span>
                      </li>
                    </ul>
                  ))}
                  <p className="repletion">
                    複数人いる場合は「入力欄を追加する」を押して一人ずつ入力してください。
                    <br />
                    あなたの名前は入れないでください。
                  </p>
                  {getItemCount('karaoke_authors') < getItemCountMax('karaoke_authors') && (
                    <CustomButton
                      type="add"
                      onClick={() => addItem('karaoke_authors')}
                    >
                      入力欄の追加
                    </CustomButton>
                  )}
                </dd>
              </dl>
            )}
            <ul>
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
                <CustomButton type="default-split" onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}

